import React, { Fragment, useEffect, useRef, useState } from "react";
import Label from "../Label";
import { Link, useNavigate } from "react-router-dom";
import RetrieveProductSettings from "../ProductSettings/RetrieveProductSettings";
import { useGlobalState } from "../GlobalContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp, faPercent } from "@fortawesome/pro-regular-svg-icons";
import { calcShippingCosts } from "./Shipping";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { getModelPrice } from "../Functions/price-calculations";
import useProductSettingsExclusions from "../Hooks/useProductSettingsExclusions";
import axios from "axios";
import { apiLabelUrl, getCurrentLabel } from "../Functions/functions";
import { buildCartBreakdownPayload, fetchCartPriceBreakdown } from "../Functions/pricingApi";
import { getSettingsId } from "../ProductSettings/Helper";
import { applyCheckoutModelRefresh, buildCheckoutModelRefreshPayload } from "./modelPriceRefresh";
import { refreshLibraryCartPrices } from "../Library/libraryCartUtils";

export default function Cart(props) {
    const navigate = useNavigate();
    const [mandatoryProductSettings, setMandatoryProductSettings] = useState([]);
    const [modelsData, setModelsData] = useState([]);
    const { productSettings, loggedInUser, labelLogo } = useGlobalState();
    const [subTotal, setSubTotal] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    const [priceBreakdown, setPriceBreakdown] = useState(null);
    const [discountOpen, setDiscountOpen] = useState(false);
    const [discounts, setDiscounts] = useState([]);
    const [, setTotalDiscount] = useState(0);
    const [totalDiscountCodeAmount, setTotalDiscountCodeAmount] = useState(0);
    const [companyDiscount, setCompanyDiscount] = useState(0);
    const isHandlingDiscountCode = useRef(false);
    const hasRefreshedCheckoutPrices = useRef(false);
    const breakdownDebounceRef = useRef(null);
    const [shippingSettled, setShippingSettled] = useState(false);
    const [libraryPricesReady, setLibraryPricesReady] = useState(false);
    const [productSettingsExclusions] = useProductSettingsExclusions(props.loggedInUser ?? loggedInUser);

    // Refresh library cart prices from backend on mount
    useEffect(() => {
        refreshLibraryCartPrices().then(() => setLibraryPricesReady(true));
    }, []);

    useEffect(() => {
        RetrieveProductSettings({ setMandatoryProductSettings });
        if (
            typeof props.modelsData !== "undefined" &&
            props.modelsData !== null &&
            Object.keys(props.modelsData).length > 0
        ) {
            let formattedData = props.modelsData[0].data.map((element) => {
                element.price = element.pivot.price;
                element.amount = element.pivot.amount;
                element.discount_multiplier = element.pivot.discount_multiplier;
                return element;
            });

            setModelsData([
                { data: formattedData, products: props.modelsData[0].products, order: props.modelsData[0].order },
            ]);
        } else {
            setModelsData(JSON.parse(localStorage.getItem("modelsData")) || []);
        }

        const settleShipping = (result) => {
            setShippingSettled(true);
            props.setShippingInfo(result);
        };

        if (typeof props.shippingCountry !== "undefined" && props.shippingCountry !== null) {
            calcShippingCosts(modelsData, productSettings, props.shippingCountry).then((response) => {
                if (typeof props.setShippingInfo !== "undefined") {
                    settleShipping(response);
                }
            });
        } else {
            if (
                document.getElementsByName("country") !== null &&
                document.getElementsByName("country").length > 0 &&
                document.getElementsByName("country")[0].value === ""
            ) {
                settleShipping(null);
            } else if (
                loggedInUser !== null &&
                typeof loggedInUser !== "undefined" &&
                loggedInUser.company !== null &&
                typeof loggedInUser.company !== "undefined"
            ) {
                calcShippingCosts(modelsData, productSettings, loggedInUser.company.country).then((response) => {
                    if (typeof props.setShippingInfo !== "undefined") {
                        settleShipping(response);
                    }
                });
            } else if (
                loggedInUser !== null &&
                typeof loggedInUser !== "undefined" &&
                loggedInUser.user !== null &&
                typeof loggedInUser.user !== "undefined"
            ) {
                calcShippingCosts(modelsData, productSettings, loggedInUser.user.country).then((response) => {
                    if (typeof props.setShippingInfo !== "undefined") {
                        settleShipping(response);
                    }
                });
            } else {
                settleShipping(null);
            }
        }
    }, []);

    useEffect(() => {
        props.setDiscounts(discounts);
    }, [discounts]);

    useEffect(() => {
        clearTimeout(breakdownDebounceRef.current);
        breakdownDebounceRef.current = setTimeout(() => {
            setSubTotalPrice();
        }, 80);
        return () => clearTimeout(breakdownDebounceRef.current);
    }, [
        modelsData,
        discounts,
        props.shippingCountry,
        props.deliveryPrice,
        props.showShippingCosts,
        productSettingsExclusions,
        loggedInUser,
        shippingSettled,
        libraryPricesReady,
    ]);

    useEffect(() => {
        if (typeof props.shippingCountry !== "undefined" && props.shippingCountry !== null) {
            calcShippingCosts(modelsData, productSettings, props.shippingCountry).then((response) => {
                if (typeof props.setShippingInfo !== "undefined") {
                    props.setShippingInfo(response);
                }
            });
        } else {
            if (
                document.getElementsByName("country") !== null &&
                document.getElementsByName("country").length > 0 &&
                document.getElementsByName("country")[0].value === ""
            ) {
                props.setShippingInfo(null);
            } else if (
                loggedInUser !== null &&
                typeof loggedInUser !== "undefined" &&
                loggedInUser.company !== null &&
                typeof loggedInUser.company !== "undefined"
            ) {
                calcShippingCosts(modelsData, productSettings, loggedInUser.company.country).then((response) => {
                    if (typeof props.setShippingInfo !== "undefined") {
                        props.setShippingInfo(response);
                    }
                });
            } else if (
                loggedInUser !== null &&
                typeof loggedInUser !== "undefined" &&
                loggedInUser.user !== null &&
                typeof loggedInUser.user !== "undefined"
            ) {
                calcShippingCosts(modelsData, productSettings, loggedInUser.user.country).then((response) => {
                    if (typeof props.setShippingInfo !== "undefined") {
                        props.setShippingInfo(response);
                    }
                });
            } else {
                props.setShippingInfo(null);
            }
        }
    }, [modelsData, props.shippingCountry]);

    useEffect(() => {
        const refreshCheckoutModelPrices = async () => {
            if (hasRefreshedCheckoutPrices.current) {
                return;
            }

            if (!Array.isArray(modelsData) || modelsData.length === 0 || !Array.isArray(modelsData[0]?.data)) {
                return;
            }

            if (!Array.isArray(productSettings) || productSettings.length === 0) {
                return;
            }

            const order = modelsData[0]?.order ?? null;
            const refreshPayload = buildCheckoutModelRefreshPayload(modelsData[0].data, order, (model) =>
                getSettingsId(model?.settings ?? {}, productSettings)
            );

            hasRefreshedCheckoutPrices.current = true;

            if (refreshPayload.length === 0) {
                return;
            }

            try {
                const baseApiUrl = await apiLabelUrl("api");
                const response = await axios.post(`${baseApiUrl}/all-product-prices`, {
                    models: refreshPayload,
                });
                const refreshedRows = response?.data?.data ?? [];

                setModelsData((prevState) => {
                    if (!Array.isArray(prevState) || prevState.length === 0 || !Array.isArray(prevState[0]?.data)) {
                        return prevState;
                    }

                    const nextData = applyCheckoutModelRefresh(
                        prevState[0].data,
                        refreshedRows,
                        prevState[0]?.order ?? null
                    );
                    const nextState = [{ ...prevState[0], data: nextData }];

                    if (typeof props.modelsData === "undefined" || props.modelsData === null) {
                        window.localStorage.setItem("modelsData", JSON.stringify(nextState));
                    }

                    return nextState;
                });
            } catch (error) {
                // Keep existing cart prices as fallback when live refresh fails.
            }
        };

        refreshCheckoutModelPrices();
    }, [modelsData, productSettings]);

    const setSubTotalPrice = async () => {
        if (!shippingSettled) return;

        try {
            const models = modelsData?.[0]?.data ?? [];
            const libraryProducts =
                typeof props.modelsData !== "undefined" &&
                props.modelsData !== null &&
                typeof props.modelsData[0] !== "undefined" &&
                props.modelsData[0]?.products !== null
                    ? props.modelsData[0].products
                    : JSON.parse(window.localStorage.getItem("productsData")) || [];

            if (models.length === 0 && libraryProducts.length === 0) {
                setSubTotal(0);
                setTotalPrice(0);
                setPriceBreakdown(null);
                return;
            }

            const labelId = await getCurrentLabel();

            const payload = buildCartBreakdownPayload({
                models,
                libraryProducts,
                discountCodes: discounts,
                customerContext: {
                    company_id: loggedInUser?.company?.id ?? null,
                    user_id: loggedInUser?.user?.id ?? null,
                    vat_number: loggedInUser?.company?.vat_number ?? null,
                    country: loggedInUser?.company?.country ?? loggedInUser?.user?.country ?? null,
                },
                deliveryContext: {
                    country: props.shippingCountry ?? null,
                    shipping_cost: props.deliveryPrice ?? 0,
                    show_shipping_costs: props.showShippingCosts === true,
                },
                orderContext: modelsData?.[0]?.order
                    ? {
                          order_id: modelsData[0].order?.id ?? null,
                          status: modelsData[0].order?.status ?? null,
                          lock_order_prices: modelsData[0].order?.lock_order_prices === true,
                      }
                    : null,
                userExclusions: productSettingsExclusions ?? [],
            });

            const breakdown = await fetchCartPriceBreakdown(labelId, payload);
            setPriceBreakdown(breakdown);
            setSubTotal(Number.parseFloat(breakdown?.subtotal ?? 0));
            setTotalPrice(Number.parseFloat(breakdown?.total ?? 0));
            setCompanyDiscount(Number.parseFloat(breakdown?.company_discount ?? 0));
            setTotalDiscountCodeAmount(Number.parseFloat(breakdown?.discount_codes_amount ?? 0));
            setTotalDiscount(
                Number.parseFloat(
                    Number.parseFloat(breakdown?.company_discount ?? 0) +
                        Number.parseFloat(breakdown?.discount_codes_amount ?? 0)
                ).toFixed(2)
            );
        } catch (error) {
            setPriceBreakdown(null);
            setSubTotal(0);
            setTotalPrice(0);
        }
    };

    const applyDiscountCode = async () => {
        // No discounts if order prices are locked
        if (
            typeof modelsData[0].order !== "undefined" &&
            modelsData[0].order !== null &&
            modelsData[0].order.lock_order_prices === true
        ) {
            toast.error(props.textData["checkout/form"]["no_discount_found"], {
                position: toast.POSITION.TOP_CENTER,
            });
            return;
        }

        if (isHandlingDiscountCode.current) {
            return;
        }
        isHandlingDiscountCode.current = true;

        if (discounts.length > 0) {
            toast.error(props.textData["checkout/form"]["one_discount_allowed"], {
                position: toast.POSITION.TOP_CENTER,
            });
            return;
        }

        //discount-input
        let code = document.getElementById("discount-input").value;
        if (code.length > 0) {
            let found = false;
            discounts.forEach((discount) => {
                if (discount.code === code) {
                    toast.error(props.textData["checkout/form"]["discount_already_applied"], {
                        position: toast.POSITION.TOP_CENTER,
                    });
                    found = true;
                }
            });
            if (found) {
                return;
            }

            axios
                .get((await apiLabelUrl("api")) + "/discount?discount_code=" + code)
                .then((response) => {
                    setDiscounts((prev) => {
                        return [...prev, response.data];
                    });
                    toast.success(props.textData["checkout/form"]["discount_applied"], {
                        position: toast.POSITION.TOP_CENTER,
                    });
                    isHandlingDiscountCode.current = false;
                })
                .catch((error) => {
                    toast.error(props.textData["checkout/form"]["no_discount_found"], {
                        position: toast.POSITION.TOP_CENTER,
                    });
                    isHandlingDiscountCode.current = false;
                });
        }
    };

    const allModels = () => {
        const handleModelClick = (model) => {
            if (typeof props.modelsData !== "undefined" && props.modelsData !== null) {
                //navigate("/", { state: { model_id: model.id } });
                const urlParams = new URLSearchParams(window.location.search);
                const id = urlParams.get("id");

                if (id !== null && typeof id !== "undefined") {
                    props.navigateToPageName("account_edit_quotation", "?id=" + id);
                } else {
                    navigate("/", { state: { model_id: model.id } });
                }
            } else {
                navigate("/", { state: { model_id: model.id } });
            }
        };

        let productsOutput = null;
        const products = JSON.parse(window.localStorage.getItem("productsData"));
        if (typeof products !== "undefined" && products !== null) {
            productsOutput = products.map((product, index) => {
                const displayName = product.name || product.file;
                return (
                    <div onClick={() => handleModelClick(product)} className="cart-item" key={index}>
                        <div className="model-image">
                            <img
                                src={typeof product.image === "undefined" ? product.preview_image : product.image}
                                alt={product.title}
                            />
                        </div>
                        <div className="model-info">
                            <p>
                                {displayName} <span className="amount">x {product.quantity}</span>
                            </p>
                            <div className="model-settings">
                                <Label
                                    model={product.file}
                                    data={product.settings}
                                    showall={true}
                                    textDataLabel={props.textData["sections/label"]}
                                    mandatoryProductOptions={mandatoryProductSettings}
                                />
                            </div>
                            {product.library_labels && product.library_labels.length > 0 && (
                                <div className="cart-product-labels">
                                    {product.library_labels.map((label, i) => (
                                        <span
                                            key={i}
                                            className="cart-product-label-chip"
                                            style={{ backgroundColor: label.color || "#6b7280" }}
                                        >
                                            {label.name}
                                        </span>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className="model-price">
                            {parseFloat(product.discount_multiplier ?? 1) !== 1 && !product.ignore_staffel_discount ? (
                                <p className="price">
                                    <s>&euro;{(product.price * product.quantity).toFixed(2)}</s>
                                    <br />
                                    &euro;{(product.price * product.discount_multiplier * product.quantity).toFixed(2)}
                                </p>
                            ) : (
                                <p className="price">&euro;{(product.price * product.quantity).toFixed(2)}</p>
                            )}
                        </div>
                    </div>
                );
            });
        }

        if (modelsData.length > 0 && modelsData[0].data.length > 0) {
            let models = modelsData[0].data.map((model, index) => {
                return (
                    <div onClick={() => handleModelClick(model)} className="cart-item" key={index}>
                        <div className="model-image">
                            <img
                                src={typeof model.image === "undefined" ? model.preview_image : model.image}
                                alt={model.title}
                            />
                        </div>
                        <div className="model-info">
                            <p>
                                {model.file} <span className="amount">x {model.amount}</span>
                            </p>
                            <div className="model-settings">
                                <Label
                                    model={model.file}
                                    data={model.settings}
                                    showall={true}
                                    textDataLabel={props.textData["sections/label"]}
                                    mandatoryProductOptions={mandatoryProductSettings}
                                />
                            </div>
                        </div>
                        <div className="model-price">
                            <p>{getModelPrice(model, loggedInUser, modelsData[0].order)}</p>
                        </div>
                    </div>
                );
            });

            if (productsOutput !== null) {
                models = [...models, ...productsOutput];
            }

            return models;
        } else if (typeof productsOutput !== "undefined" && productsOutput !== null) {
            return productsOutput;
        } else {
            return <p>Geen items in winkelmand</p>;
        }
    };

    const toggleDiscount = () => {
        const discountCode = document.querySelector(".discount-code");
        discountCode.classList.toggle("discount-open");
        setDiscountOpen(!discountOpen);
    };

    const getBtw = () => {
        return Number.parseFloat(priceBreakdown?.vat ?? 0);
    };

    const getExtraOrderCosts = () => {
        const mandatoryCosts = priceBreakdown?.mandatory_costs ?? [];
        if (mandatoryCosts.length === 0) {
            return false;
        }

        return mandatoryCosts.map((element, index) => (
            <Fragment key={index}>
                {/* Manual cost lines (e.g. a hand-added discount on a quotation) carry their own name */}
                <p>{element.is_manual ? element.name : props.textData["popups/order_overview"]["one_time_fee"]}</p>
                <p>€ {Number.parseFloat(element.price ?? 0).toFixed(2)}</p>
            </Fragment>
        ));
    };

    const shouldRenderBtw = () => {
        return getBtw() > 0;
    };

    const renderBtw = () => {
        if (shouldRenderBtw()) {
            return (
                <>
                    <p>{props.textData["checkout/form"]["vat"]} (21%)</p>
                    <p>€ {getBtw().toFixed(2)}</p>
                </>
            );
        }
    };

    const getSubtotalIncludingMinimumOrderCosts = () => {
        const surcharge = Number.parseFloat(priceBreakdown?.minimum_order_surcharge ?? 0);
        return Number.parseFloat((subTotal ?? 0) + surcharge).toFixed(2);
    };

    return (
        <Fragment>
            <div className="cart-container">
                <div>
                    <Link to={"/"}>
                        <img src={labelLogo?.url} className="logo" alt="logo" />
                    </Link>
                    {!!props.textData && (
                        <div
                            className={
                                modelsData[0] !== null &&
                                typeof modelsData[0] !== "undefined" &&
                                !!modelsData[0].data &&
                                modelsData[0].data.length > 2
                                    ? "cart scrollable-cart"
                                    : "cart"
                            }
                        >
                            {allModels()}
                        </div>
                    )}
                </div>
                <div className="cart-calculations">
                    <div className="reference-container">
                        <label htmlFor="reference">{props.textData["checkout/form"]["reference"]}</label>
                        <input
                            type="text"
                            name="reference"
                            id="reference"
                            placeholder={props.textData["checkout/form"]["reference_placeholder"]}
                        />
                    </div>
                </div>
                <div className="calculations-container">
                    <span className="divider"></span>
                    <span className="divider"></span>
                    {(priceBreakdown?.minimum_order_surcharge ?? 0) > 0 && (
                        <>
                            <p>Minimum order kosten</p>
                            <p>€&nbsp;{Number.parseFloat(priceBreakdown?.minimum_order_surcharge ?? 0).toFixed(2)}</p>
                        </>
                    )}

                    {<>{getExtraOrderCosts()}</>}
                    <p>{props.textData["checkout/form"]["subtotal"]}</p>
                    <p>€ {getSubtotalIncludingMinimumOrderCosts()}</p>
                    {discounts.length > 0 && (
                        <>
                            {discounts.map((discount, index) => {
                                return (
                                    <Fragment key={index}>
                                        <p className="discount">
                                            {" "}
                                            {props.textData["checkout/form"]["discount_code"]}{" "}
                                            <span className="discount-code">({discount.code})</span>
                                        </p>
                                        <p className="discount">{"€ -" + totalDiscountCodeAmount.toFixed(2)}</p>
                                    </Fragment>
                                );
                            })}
                        </>
                    )}
                    {loggedInUser?.company?.price_settings !== null &&
                        loggedInUser?.company?.price_settings.discount > 0 &&
                        companyDiscount > 0 &&
                        !loggedInUser?.company?.price_settings.fixed_discount && (
                            <>
                                <p className="discount">
                                    {" "}
                                    {props.textData["checkout/form"]["company_discount"]}{" "}
                                    {"(" + parseFloat(loggedInUser?.company?.price_settings.discount) + "%)"}
                                </p>
                                <p className="discount">{"€ -" + companyDiscount.toFixed(2)}</p>
                            </>
                        )}
                    {loggedInUser?.company?.price_settings !== null &&
                        loggedInUser?.company?.price_settings.discount > 0 &&
                        companyDiscount > 0 &&
                        !!loggedInUser?.company?.price_settings.fixed_discount && (
                            <>
                                <p className="discount">
                                    {" "}
                                    {props.textData["checkout/form"]["company_discount"]}{" "}
                                    {"(€-" + companyDiscount.toFixed(2) + ")"}
                                </p>
                                <p className="discount">{"€ -" + companyDiscount.toFixed(2)}</p>
                            </>
                        )}
                    {(priceBreakdown?.shipping ?? 0) > 0 && (
                        <>
                            <p>{props.textData["checkout/form"]["shipping_costs"]}</p>
                            <p>€ {Number.parseFloat(priceBreakdown?.shipping ?? 0).toFixed(2)}</p>
                        </>
                    )}
                    {renderBtw()}
                    <span className="divider"></span>
                    <span className="divider"></span>
                    <p>
                        <b>{props.textData["checkout/form"]["totalprice"]}</b>
                        {shouldRenderBtw() && <> incl. {props.textData["checkout/form"]["vat"]}</>}
                    </p>
                    <p>€{Number.parseFloat(totalPrice ?? 0).toFixed(2)}</p>
                </div>
                <br />
                {(priceBreakdown?.minimum_order_surcharge ?? 0) > 0 &&
                    loggedInUser?.company?.price_settings.minimum_order_amount !== null && (
                        <p>
                            Let op: er is een minimum order bedrag van &euro;
                            {Number.parseFloat(loggedInUser?.company?.price_settings.minimum_order_amount).toFixed(2)}
                        </p>
                    )}
            </div>
            <div className="discount-code">
                <button className="toggleDiscount" onClick={toggleDiscount}>
                    {discountOpen && <FontAwesomeIcon size="lg" icon={faChevronUp} />}
                    {!discountOpen && <FontAwesomeIcon size="lg" icon={faChevronDown} />}
                </button>
                <p>
                    <FontAwesomeIcon icon={faPercent} /> &nbsp;{props.textData["checkout/form"]["apply_discount"]}
                </p>
                {discountOpen && (
                    <>
                        <input
                            type="text"
                            name="discount"
                            id="discount-input"
                            placeholder={props.textData["checkout/form"]["fill_your_discount_here"]}
                        />
                        <button className="discount-button" onClick={applyDiscountCode}>
                            {props.textData["checkout/form"]["apply"]}
                        </button>
                    </>
                )}
            </div>
        </Fragment>
    );
}
